import React from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import { BrowserRouter as Router } from 'react-router-dom'
import ErrorBoundary from './archived/utils/ErrorBoundary'
import App from './App'
import { Route, Routes } from 'react-router-dom'
import Detail from './Detail'
import Now from './Now'

import { Layout } from './components/layout/Layout'

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route
            exact={true}
            path={'/'}
            element={
              <Layout>
                <App />
              </Layout>
            }
          />
          <Route
            path={'/projects'}
            element={
              <Layout>
                <Detail />
              </Layout>
            }
          />
          <Route
            path={'/now'}
            element={
              <Layout>
                <Now />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>,
)
